import { cleanStringFromNonDigits } from '@hrlogics/helper-utils';

import { FEIN_MASK } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';
import { formatWithMask } from '@clearverify/utils';

export const formatFeinNumber = (feinNumber: Nullable<string>) => {
  if (!feinNumber) return null;
  return formatWithMask(feinNumber, FEIN_MASK);
};

export const clearFein = (feinNumber: string) => {
  return cleanStringFromNonDigits(feinNumber);
};
